import { setupUi } from '@payjib/ui'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  setupUi(nuxtApp.vueApp)
})
